


import * as Actions from '../actions';

const initialState = {
    isLoading: true,
    errMsg: null,
    data: []
    };


// get active categories
export const AdminSignInReducer = function(state = initialState, action) {
switch (action.type) {
case Actions.ADMIN_SIGN_IN:
return { ...state, isLoading: false, errMsg: null, data: action.payload };
case Actions.ADMIN_SIGN_IN_LOADING:
return { ...state, isLoading: true, errMsg: null, data: [] };
case Actions.ADMIN_SIGN_IN_LOADING_FAILED:
return { ...state, isLoading: false, errMsg: action.payload, data: [] };
default:
return state;
}
};
